import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SponsorsMobile = ({ sponsors }) => {
  if (!sponsors || sponsors.length === 0) {
    return null;
  }

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    className: "sponsors-slider",
    arrows: false,
    centerMode: false,
    variableWidth:false,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 320,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          centerPadding: '20px',
        }
      }
    ]
  };

  const sponsorsSectionStyle = {
    width: '100%',
    margin: '24px 0',
    padding: '20px 0 50px 0', 
  };

  const sponsorItemStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    minHeight: '80px',
    maxHeight: '80px',
    padding: '12px 8px',

    transition: 'all 0.3s ease'
  };

  const sponsorLogoStyle = {
    maxWidth: '90%',
    maxHeight: '55px',
    margin: '0 auto',
    objectFit: 'contain',
  };


  return (
    <div style={sponsorsSectionStyle}>
      <Slider {...settings}>
        {sponsors.map((sponsor) => (
          <div key={sponsor.id}>
            <div 
              style={sponsorItemStyle}
              onTouchStart={(e) => {
                e.currentTarget.style.transform = 'scale(0.95)';
              }}
              onTouchEnd={(e) => {
                e.currentTarget.style.transform = 'scale(1)';
              }}
            >
              <img 
                src={sponsor.url} 
                alt={sponsor.nombre}
                title={sponsor.nombre}
                style={sponsorLogoStyle}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default SponsorsMobile;